import { PropsWithChildren, forwardRef, useContext } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Loading from 'modules/layout/components/Page/Loading'
import { PageContext } from 'modules/layout/components/Page/Provider'

import styles from './index.vanilla.css'

interface Props {
  size?: 'narrow' | 'full' | 'wide'
  withoutPadding?: boolean
}

export default forwardRef<HTMLDivElement, PropsWithChildren<Props>>(function Body(
  { children, withoutPadding, size },
  ref
) {
  const isLoading = useContext(PageContext)
  const paddingStyle = withoutPadding ? styles.withoutPadding : undefined
  let sizeStyle: string

  switch (size) {
    case 'narrow':
      sizeStyle = styles.narrow
      break
    case 'full':
      sizeStyle = styles.full
      break
    default:
      sizeStyle = styles.wide
  }

  return (
    <Box className={`${sizeStyle} ${paddingStyle}`} ref={ref}>
      {isLoading ? <Loading /> : children}
    </Box>
  )
})
